import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { keys } from "@/data/keys";

type ProducerPatch = Partial<{
  description: string | null;
  website_url: string | null;
  instagram_url: string | null;
  logo_url: string | null;
}>;

/**
 * Single-field (or multi-field) update for a producer row.
 * Caller is responsible for RLS — only the producer's creator can update.
 */
export function useUpdateProducer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, patch }: { id: string; patch: ProducerPatch }) => {
      const { error } = await supabase.from("producers").update(patch).eq("id", id);
      if (error) throw error;
      return { id, patch };
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: keys.producers.all });
    },
  });
}
